import http from "@/axios";
import {ContentDto} from "@/store/chest/types";
import {Player, WheelStatusDto} from "@/store/player/types";
import PlayerStore from "@/store/player";

export default class ChestStore {

    public static ensureChestContent(): Promise<ContentDto[]> {
        return http.get('/api/chest/ensure')
            .then(r => r.data)
            .then(contentObj => {
                let res: ContentDto[] = [];
                for (let obj of contentObj) {
                    let sc = Object.assign(new ContentDto(), obj);
                    res.push(sc);
                }
                return res;
            });
    }

    public static takeChestContent(chestContentId: number, optionalCreatureId: number | null | undefined): Promise<void> {
        return http.get('/api/chest/take?chestContentId='
            + String(chestContentId) + (optionalCreatureId ? '&optionalCreatureId=' + String(optionalCreatureId) : ''))
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
            });
    }

}